export const firstLetterUppercase = (text: string): string => `${text[0].toUpperCase()}${text.substr(1).toLowerCase()}`

export const handleize = (text: string, prefix?: string): string => `${prefix || ''} ${text}`.toLowerCase().trim().replace(/\s/g, '-')

export const parseEntities = (text: string): string => new DOMParser().parseFromString(text, 'text/html').body.innerText